<template lang="pug">
  b-field(:type="{'is-danger': error(input_name, errors)}"
           :message="errorMessageFor(input_name, errors)")
    b-autocomplete(
      data-vv-as="sales_person_id"
      :name="input_name"
      size="is-small"
      v-model="internalValue"
      :disabled="disabled"
      :loading="loading"
      :data="filteredDataObj"
      field="formattedName"
      open-on-focus
      class="fully-visible-autocomplete"
    )
    | {{ salesPersonName }}

</template>

<script>
  import ErrorDisplayer from 'mixins/error_displayer'

  export default {
    name: 'sales-person-id-input',
    mixins: [ErrorDisplayer],
    data() {
      return {
      }
    },
    props: {
      input_name: {
        type: String,
        required: true
      },
      value: '',
      disabled: {
        type: Boolean,
        required: false
      },
      sales_people: {
        type: Array,
        required: true,
        default: []
      },
      data_vv_scope: {
        type: String,
        required: false,
      },
       errors: {
         required: false
       }
    },
    computed: {
      loading(){
        return 0 == this.sales_people.length
      },
      internalValue: {
        get() {
          return this.value
        },
        set(newVal) {
          var salesPersonId = this.salesPersonId(newVal)
          if (this.value !== salesPersonId) this.$emit('input', salesPersonId)
        }
      },
      salesPersonName() {
        var obj = this.sales_people.filter((person) => {
          return person.id == this.internalValue
        })
        if(obj.length == 1) {
          return obj[0].name
        } else {
          return ""
        }
      },
      filteredDataObj() {
        return this.sales_people.filter((person) => {
          this.setFormattedName(person)
          return `${person.id} ${person.name}`.indexOf(this.internalValue) >= 0
        })
      }
    },

    methods: {
      salesPersonId(value) {
        var people = this.sales_people.filter((person) => {
          if(person.id == value || person.name == value || person.formattedName == value)
            return true
        })
        if(people.length == 1) {
          return `${people[0].id}`
        } else {
          return value
        }
      },
      setFormattedName(person) {
        person.formattedName = person.id + ' ' + person.name
      }
    },
    created() {
    },
  }
</script>